import { Box, Typography } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import { Outlet } from 'react-router-dom';

import { romie } from '@/styles/fonts/romie';
import { inter, playfair } from '@/styles/themes/common';

// Applying each webfont's `.variable` here marks it "used" on every print
// route, so next/font preloads it. Without this, a font referenced only via
// its `fontFamily` string (e.g. Romie on branded headers) loads lazily and can
// miss the headless PDF capture — falling back to serif. We preload all of
// them regardless of which the tenant's branding selects, since the capture is
// headless and can't lazily fetch a font mid-render. (Arial needs no preload —
// it's a system font in the `Arial, Helvetica, sans-serif` stack.)
const PRINT_FONT_VARIABLES = `${inter.variable} ${playfair.variable} ${romie.variable}`;

function PrintableRouteFallback() {
  return (
    <Typography variant="title-xl">
      Failed to generate printable document
    </Typography>
  );
}

export function PrintOnlyLayout() {
  return (
    <ErrorBoundary fallback={PrintableRouteFallback}>
      <Box
        className={PRINT_FONT_VARIABLES}
        sx={(theme) => ({ backgroundColor: theme.palette.background.paper })}
      >
        <Outlet />
      </Box>
    </ErrorBoundary>
  );
}
